import {menuItemT, menuTitleT} from '@/lib/types/nav.types';

// Utility function to remove the first item if it's a menuTitleT
export const removeMenuTitle = (items: (menuTitleT | menuItemT)[]): menuItemT[] => {
  // Check if the first item is a menuTitleT by checking the 'menutitle' key
  if (items.length > 0 && 'menutitle' in items[0]) {
    // Remove the first item
    return items.slice(1) as menuItemT[];
  }
  return items as menuItemT[];
};
